const state = () => ({
    _quickActionsDropdown: false,
    typeActionSelected: ""
})

// getters
const getters = {
        quickActionsDropdown: (state) => {
            return state._quickActionsDropdown
        },
        typeActionSelected: (state) => {
            return state.typeActionSelected
        }
    }
    // mutations
const mutations = {
    SET_QUICKACTIONS(state, q) {
        state._quickActionsDropdown = q
    },
    SET_TYPE_ACTION_SELECTED(state, action) {
        state.typeActionSelected = action
    }
}

//actions
const actions = {
    setQuickActionsDropdown({ commit }, q) {
        commit('SET_QUICKACTIONS', q)
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}